import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the CSS for Quill editor
import { removeHtmlTagsAndEntities } from "../../utils";
import './RFH.scss';
import JoditEditor from "../Editor/JoditEditor";

// ----------------------------------------------------------------------

function RHFTextEditor({ name, minHeight, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      className="text-editor"
      render={({ field, fieldState: { error } }) => (
        <div style={{ minHeight: "172px" }}>
          <ReactQuill
            value={field.value}
            onChange={(value) =>
              removeHtmlTagsAndEntities(value).length === 0
                ? field.onChange("")
                : field.onChange(value)
            }
            onBlur={field.onBlur}
            style={{ height: minHeight }}
            {...other}
          />
          {/* <JoditEditor
            value={field.value}
            // onChange={(value) =>
            //   removeHtmlTagsAndEntities(value).length === 0
            //     ? field.onChange("")
            //     : field.onChange(value)
            // }
            onBlur={(value) =>{
              removeHtmlTagsAndEntities(value).length === 0
                ? field.onChange("")
                : field.onChange(value)
                
              field.onBlur()
            }
              }
            style={{ height: minHeight }}
            {...other}
          /> */}
          {error && <p className="error-message">{error.message}</p>}
        </div>
      )}
    />
  );
}

export default React.memo(RHFTextEditor);
